import React from "react";
import Img from "gatsby-image"
import styled from "styled-components";

const ImgWrapper = styled.div`
    max-width: 100%;
`

const Gap = styled.div`

`

const TeaserImgEvent = ({teaser_img_event}) => {
  return (
    <Gap>
      <ImgWrapper>
          <Img fluid={teaser_img_event.localFiles[0].childImageSharp.fluid} alt="Teaser image" />
      </ImgWrapper>
    </Gap>
  );
};

export default TeaserImgEvent;
